import { useMemo } from 'react';
import MarkdownIt from 'markdown-it';
import { markdownParserOptions } from './config';
import { markdownStrikethroughPlugin } from './markdownPlugins';

export const useMarkdownParser = (): MarkdownIt => {
  const parser = useMemo(() => {
    const md = new MarkdownIt(markdownParserOptions);
    md.use(markdownStrikethroughPlugin);
    return md;
  }, []);

  return parser;
};
